/*
 * Public API Surface of ngx-lib/separator
 */
export * from './separator.module';
export * from './separator.component';
